import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />

      <section className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6">
          {/* Titre principal */}
          <h1 className="text-2xl md:text-3xl font-serif font-semibold text-gray-800 mb-2">
            Politique de confidentialité
          </h1>
          <p className="text-sm text-gray-400 mb-8">
            Dernière mise à jour : 27/03/2026
          </p>

          <p className="text-sm text-gray-600 leading-relaxed mb-10">
            EFFET CONSEIL s'engage à protéger vos données personnelles
            conformément au RGPD (Règlement UE 2016/679) et à la loi
            Informatique et Libertés.
          </p>

          {/* Responsable du traitement */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Responsable du traitement
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-1">
            <p>SAS EFFET CONSEIL</p>
            <p>382 rue de Saint-Martin</p>
            <p>17580 Le Bois-Plage-en-Ré</p>
            <p>christelle@effet-conseil.com</p>
            <p>06 40 86 81 29</p>
          </div>

          {/* Données collectées */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Données collectées
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-3">
            <div>
              <p className="font-medium text-gray-700">
                Via le formulaire de contact :
              </p>
              <p>
                Nom, prénom, organisme, email, téléphone (facultatif), type de
                besoin, message.
              </p>
            </div>
            <div>
              <p className="font-medium text-gray-700">
                Données de navigation :
              </p>
              <p>
                Adresse IP, type de navigateur, pages consultées, durée de
                visite (via cookies).
              </p>
            </div>
            <p>
              Les champs marqués d'un astérisque (*) sont obligatoires pour
              traiter votre demande.
            </p>
          </div>

          {/* Finalités et conservation */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Finalités et conservation
          </h2>
          <div className="mb-8 overflow-x-auto">
            <table className="w-full text-sm text-gray-600 border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-2 pr-4 font-medium text-gray-700">
                    Finalité
                  </th>
                  <th className="text-left py-2 pr-4 font-medium text-gray-700">
                    Base légale
                  </th>
                  <th className="text-left py-2 font-medium text-gray-700">
                    Conservation
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="py-2 pr-4">
                    Traitement de votre demande de contact
                  </td>
                  <td className="py-2 pr-4">Consentement</td>
                  <td className="py-2">3 ans après le dernier contact</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-2 pr-4">
                    Gestion de la relation client
                  </td>
                  <td className="py-2 pr-4">Exécution du contrat</td>
                  <td className="py-2">Durée du contrat + 5 ans</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-2 pr-4">
                    Obligations légales (comptabilité)
                  </td>
                  <td className="py-2 pr-4">Obligation légale</td>
                  <td className="py-2">10 ans</td>
                </tr>
                <tr>
                  <td className="py-2 pr-4">Statistiques anonymisées</td>
                  <td className="py-2 pr-4">Intérêt légitime</td>
                  <td className="py-2">Illimitée (données anonymes)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Destinataires */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Destinataires
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-2">
            <p>Vos données sont accessibles uniquement à :</p>
            <p>
              — EFFET CONSEIL (Christelle Charrier-Robelin et collaborateurs
              habilités)
            </p>
            <p>
              — Prestataires techniques (hébergeur, outils de gestion) agissant
              comme sous-traitants
            </p>
            <p>
              EFFET CONSEIL ne vend ni ne partage vos données à des tiers.
            </p>
          </div>

          {/* Sécurité */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Sécurité
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            Nous mettons en œuvre des mesures de sécurité appropriées :
            hébergement sécurisé (HTTPS), accès restreints, sauvegardes
            régulières.
          </p>

          {/* Vos droits */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Vos droits
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-2">
            <p>Vous disposez des droits suivants :</p>
            <p>
              <span className="font-medium text-gray-700">Accès</span> :
              obtenir une copie de vos données
            </p>
            <p>
              <span className="font-medium text-gray-700">Rectification</span>{" "}
              : corriger vos données inexactes
            </p>
            <p>
              <span className="font-medium text-gray-700">Effacement</span> :
              supprimer vos données
            </p>
            <p>
              <span className="font-medium text-gray-700">Limitation</span> :
              limiter le traitement de vos données
            </p>
            <p>
              <span className="font-medium text-gray-700">Portabilité</span> :
              recevoir vos données dans un format lisible
            </p>
            <p>
              <span className="font-medium text-gray-700">Opposition</span> :
              vous opposer au traitement
            </p>
            <p>
              <span className="font-medium text-gray-700">
                Retrait du consentement
              </span>{" "}
              : retirer votre accord à tout moment
            </p>
            <div className="mt-4 space-y-1">
              <p className="font-medium text-gray-700">
                Pour exercer vos droits :
              </p>
              <p>christelle@effet-conseil.com</p>
              <p>
                EFFET CONSEIL, 382 rue de Saint-Martin, 17580 Le
                Bois-Plage-en-Ré
              </p>
              <p>
                Joignez une copie de votre pièce d'identité. Réponse sous 1
                mois.
              </p>
            </div>
            <p className="mt-4">
              <span className="font-medium text-gray-700">Réclamation</span> :
              si vous estimez que vos droits ne sont pas respectés, contactez la
              CNIL :{" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#62751D] hover:underline">
                www.cnil.fr
              </a>
            </p>
          </div>

          {/* Cookies */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Cookies
          </h2>
          <div className="text-sm text-gray-600 leading-relaxed mb-8 space-y-3">
            <div>
              <p className="font-medium text-gray-700">
                Qu'est-ce qu'un cookie ?
              </p>
              <p>
                Un petit fichier déposé sur votre appareil lors de votre visite,
                permettant d'améliorer votre navigation et de réaliser des
                statistiques.
              </p>
            </div>
            <div>
              <p className="font-medium text-gray-700">
                Types de cookies utilisés :
              </p>
              <p className="mt-1">
                <span className="font-medium text-gray-700">
                  Cookies techniques (obligatoires) :
                </span>{" "}
                nécessaires au fonctionnement du site (sécurité, session).
              </p>
              <p className="mt-1">
                <span className="font-medium text-gray-700">
                  Cookies statistiques (facultatifs) :
                </span>{" "}
                mesure d'audience anonyme (Google Analytics ou similaire).
              </p>
            </div>
            <div>
              <p className="font-medium text-gray-700">
                Gestion des cookies :
              </p>
              <p>
                Vous pouvez accepter ou refuser les cookies via le bandeau qui
                s'affiche lors de votre première visite. Vous pouvez modifier
                vos préférences à tout moment via les paramètres de votre
                navigateur.
              </p>
              <p className="mt-1">
                Plus d'infos :{" "}
                <a href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser" target="_blank" rel="noopener noreferrer" className="text-[#62751D] hover:underline">
                  www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser
                </a>
              </p>
            </div>
          </div>

          {/* Modifications */}
          <h2 className="text-base font-semibold text-gray-700 mb-3">
            Modifications
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            Cette politique peut être modifiée à tout moment. La version en
            vigueur est celle publiée sur le site.
          </p>

          {/* Contact final */}
          <div className="pt-6 border-t border-gray-100">
            <p className="text-sm text-gray-500">
              Pour toute question relative à vos données personnelles,
              contactez-nous : christelle@effet-conseil.com
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>;
}